import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let current_location_id = useDataValue({
    viewPath: props.viewPath,
    context: 'event',
    path: 'appointment.booking.0.chair.resource.organization._id',
  })

  return {
    variables: {
      current_location_id,
    },
    pause: !current_location_id,
  }
}
